// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgStyle, NgTemplateOutlet, SlicePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { IconComponent } from '@lbca-shared/icon';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EntityFieldsComponent } from '../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { AdditionalValuesCondensedComponent } from '../fields/additional-values-condensed/additional-values-condensed.component';
import { AdditionalValuesComponent } from '../fields/additional-values/additional-values.component';
import { DatePickerComponent } from '../fields/date-picker/date-picker.component';
import { DateTimePickerComponent } from '../fields/date-time-picker/date-time-picker.component';
import { InputCheckmarkComponent } from '../fields/input-checkmark/input-checkmark.component';
import { InputHiddenComponent } from '../fields/input-hidden/input-hidden.component';
import { InputReferenceComponent } from '../fields/input-reference/input-reference.component';
import { InputTextComponent } from '../fields/input-text/input-text.component';
import { TableListComponent } from '../fields/table-list/table-list.component';
import { TextareaComponent } from '../fields/textarea/textarea.component';
import { TimePickerRefComponent } from '../fields/timepicker/timepicker.component';
import { ModalDirective, ModalInterfaceComunication } from '../modal-overlay/modal.directive';
import { ClickTableOutsideDirective, TableDirective } from '../table/table.directive';
import { TopSticky } from '../table/table.model';

@Component({
  selector: 'lbca-table-secondary',
  templateUrl: './table-secondary.component.html',
  styleUrl: './table-secondary.component.scss',
  imports: [
    NgClass,
    NgStyle,
    InputCheckmarkComponent,
    TableDirective,
    NgTemplateOutlet,
    ClickTableOutsideDirective,
    forwardRef(() => TableListComponent),
    InputHiddenComponent,
    InputReferenceComponent,
    forwardRef(() => AdditionalValuesCondensedComponent),
    forwardRef(() => AdditionalValuesComponent),
    InputTextComponent,
    DateTimePickerComponent,
    DatePickerComponent,
    TimePickerRefComponent,
    forwardRef(() => EntityFieldsComponent),
    TextareaComponent,
    SlicePipe,
    IconComponent,
  ],
})
export class TableSecondaryComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  private overlay = inject(Overlay);
  private router = inject(Router);

  private modalController = new ModalInterfaceComunication();

  @HostBinding('attr.lbcaControllerModal') lbcaModal = new ModalDirective(
    this.overlay,
    this.modalController
  );

  @ViewChild('ModalText') textModal!: TemplateRef<any>;

  table!: any;
  fase!: any;

  @Input('table') set tb(val: any) {
    this.table = val;
  }

  @Input() fixedTop!: TopSticky;
  @Input() disabled: boolean = true;
  @Input() lineCickable: boolean = true;
  @Input() enableCheckItens: boolean = true;
  @Input() openExpanded: boolean = false;
  @Input() saveOnChange: boolean = false;

  @Input() paginationType: 'next' | 'prev' | 'choose' = 'next';
  @Input() totalPagesValue: number = 0;
  @Input() bodyLength: number = 0;
  @Input() formType: 'form-primary' | 'modal' = 'modal';
  @Input() checkItens: 'all' | 'none' | 'almost' = 'all';
  @Input() checkboxEntityKey: string = '';
  @Input()
  set removeLine(line) {
    if (!line) return;
    this.lineRemove.push(line);
  }

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  @Input('fase') set claimPhase(val) {
    this.fase = val;
  }

  @Input()
  set rightDeslocation(line) {
    if (!line) return;

    const check = this.goRight.some((check) => check.id === line.id);

    if (!check) {
      this.goRight.push(line);
    } else {
      this.goRight = this.goRight.filter((item) => item.id !== line.id);
    }
  }

  @Output('checkedItens') checkedItensEmmiter = new EventEmitter();
  @Output('saveChanges') saveEmmiter = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output() order = new EventEmitter();
  @Output() clickLine = new EventEmitter();

  @ViewChild('itemList', { static: false }) itemList!: ElementRef;
  @ViewChild('inputValue', { static: false }) inputValue!: ElementRef;
  @ViewChild('inputValueAsc', { static: false }) inputValueAsc!: ElementRef;

  public modalItems: any;

  private typingTimer;
  public enabledSearch: boolean = false;
  public directionOrder: 'ASC' | 'DESC' = 'ASC';
  public orderBy!: string;

  private total!: any;

  private goRight: any = [];
  private lineRemove: any = [];

  subscription!: Subscription;

  public openModal(lane: any): void {
    this.modalItems = lane;
    this.modalItems.dataCriacao = moment.unix(this.modalItems.createdAt).format('LL');
    this.modalController.showModal(this.textModal);
  }

  public closeModal(): void {
    this.modalController.closeModal();
    setTimeout(() => (this.modalItems = null), 1000);
  }

  getInicials(name: string) {
    const nameTreatment = name || 'Usuario Teste';
    const nameSplited: Array<string> = nameTreatment.split(' ');
    if (nameSplited.length > 1) {
      return nameSplited[0].slice(0, 1).toUpperCase() + nameSplited[1].slice(0, 1).toUpperCase();
    } else {
      return nameSplited[0].slice(0, 2).toUpperCase();
    }
  }

  checkLineDeslocation(lane) {
    return this.goRight.some((check) => check.id === lane.id);
  }

  checkLineRemove(lane) {
    return this.lineRemove.some((check) => check.id === lane.id);
  }

  getPercents(col) {
    const percent = Math.round((col / this.total) * 100);
    return `${percent}%`;
  }

  ngOnInit() {
    // GAMBIARRA POR CAUSA DO ICONE DE COLAPSE
    this.total = 1;
    this.table.columns.forEach((col) => {
      this.total += col.col;
    });
    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((val) => this.modalController.closeModal());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bodyLength']) {
      if (changes['bodyLength'].currentValue > 3) this.enabledSearch = true;
      else this.enabledSearch = false;
    }
    if (changes['table']) {
      this.table = changes['table'].currentValue;
      if (changes['table'].currentValue.body.length > 3) this.enabledSearch = true;
      else this.enabledSearch = false;
    }
  }

  ngAfterViewInit() {
    const name = this.getDefaultOrder();
    if (!name) return;
    this.orderTable(name, 'ASC');
    setTimeout(() => (this.orderBy = name), 20);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  abre(ev: HTMLDivElement, angleRef: HTMLDivElement, headerRef: HTMLDivElement) {
    if (ev.classList.contains('open')) {
      ev.classList.remove('open');
      ev.classList.add('close');
      angleRef.classList.remove('rotate-180');
      headerRef.classList.remove('shadow');
      setTimeout(() => {
        ev.classList.remove('visibleStrategy');
      }, 510);
    } else {
      ev.classList.remove('close');
      ev.classList.add('visibleStrategy');
      ev.classList.add('open');
      angleRef.classList.add('rotate-180');
      headerRef.classList.add('shadow');
    }
  }

  public clickTableLine(line) {
    if (this.lineCickable) this.clickLine.emit(line);
  }

  public orderTableEvent($event, name, value) {
    $event.stopPropagation();
    this.orderTable(name, value);
  }

  private orderTable(name, value) {
    let directionOrder;

    if (value.checked) directionOrder = 'DESC';
    else directionOrder = 'ASC';

    const orderReponse = {
      directionOrder,
      propertyOrder: name,
    };

    this.order.emit(orderReponse);
  }

  public orderTableSend($event, name, value) {
    $event.stopPropagation();

    this.directionOrder = value;
    this.orderBy = name;

    const orderReponse = {
      directionOrder: value,
      propertyOrder: name,
    };

    this.order.emit(orderReponse);
  }

  public getHeadCss(col) {
    return col?.cssHeader;
  }

  public stopPropagation($event) {
    $event.stopPropagation();
  }

  public openSearch(self, inputSearch) {
    if (self.checked) {
      inputSearch.focus();
    }
  }

  private getDefaultOrder() {
    const defaultColumn = this.table.columns.find((col) => col.orderDefault === true);
    return defaultColumn ? defaultColumn.name : null;
  }

  changeCheckedItens(obj) {
    this.checkedItensEmmiter.emit(obj);
  }

  changeValueAdditional($event, fields, lane) {
    const entityKey = $event.entityKey;
    for (const groups of fields) {
      if (groups.entityKey === entityKey) {
        this.changeValue($event, groups, lane);
      }
      if (groups.fields.length) {
        const grpFields = groups.fields;
        for (const items of grpFields) {
          if (items.length) {
            for (const fields of items) {
              if (fields.entityKey === entityKey) {
                this.changeValue($event, fields, lane);
              }
            }
          }
        }
      }
    }
  }

  changeValue(val: any, obj: any, lane) {
    const montaObj = obj;
    if (val.value || val) montaObj.value = val?.value ?? val ?? null;
    this.changeEmmiter.emit({ lane, montaObj });
    if (this.saveOnChange) this.saveEmmiter.emit({ lane, montaObj });
  }

  private sendSerach(value) {
    this.order.emit({
      searchCriteria: value,
    });
  }

  public searchString(inputSearch) {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => this.sendSerach(inputSearch.value), 300);
  }
}
